export default "__VITE_ASSET__Bi3k0eEI__"